'use strict';

$('.refinement-header').on('click', function () {
    $(this).toggleClass('active');
});

$('.menu-group-title-expand, .pt_order .menu-group-title-expand').click(function () {
    //collapse all when tapping on open group
    if ($(this).hasClass('expanded')) {
        $('.menu-group-title-expand').removeClass('expanded');
        $('.menu-group ul.mobile-only').removeClass('expanded');
        $(this).parents('.menu-group').removeClass('active');
    } else {
        // tapping on new group, collapse open group and open new group
        $('.menu-group-title-expand').removeClass('expanded');
        $('.menu-group ul.mobile-only').removeClass('expanded');
        $(this).parents('.menu-group').addClass('active');
        $(this).addClass('expanded');
        $(this).parent().children('.mobile-only').addClass('expanded');
    }
});
$(".drawerHeading").on("click", function() {
    var $this = $(this);
    if($this.hasClass('active')) {
        $(".drawerHeading.active").removeClass('active');
        $(".drawer-container .drawerContent").css("display", "none");
        $this.removeClass("active");
        var rel = $this.attr("rel");
        $this.parent().find(".drawerContent"+ "." + rel).css("display", "none");
    } else {
        $(".drawerHeading.active").removeClass('active');
        $(".drawer-container .drawerContent").css("display", "none");
        $this.addClass("active");
        var rel = $this.attr("rel");
        $this.parent().find(".drawerContent"+ "." + rel).css("display", "block");
    }
});

$(".size-chart .tabs button").on("click", function(e) {
    $(".size-chart .tabs li").removeClass("active");
    var $this = $(this);
    $this.closest("li").addClass("active");
    var relTab = $this.closest("li").attr("rel");
    $(".tab-container .tabContent").css("display","none");
    $(".tab-container .tabContent .drawingHeading.active").removeClass("active");
    $(".tab-container " + "." + relTab).css("display","block");
    $(".tab-container " + "." + relTab).find(".first").addClass("active");
    $(".tab-container " + "." + relTab).find(".first").siblings(".drawerContent").css("display","block");
});
$(document).ready(function() {
    if($(".button-wrapper").length > 0) {
        $(".button-wrapper .button").addClass("btn").addClass("btn-primary");
    }

});